/**
 * Private route
 */

// React
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Components
import AppLayout from 'app/AppLayout';

// Hooks
import useLocalStorage from 'hooks/useLocalStorage';

// Utils
import { STORAGE_KEYS } from 'utils/constants';

// Router
import ROUTES from 'configs/route';

// Services
import AuthService from 'services/AuthService';

// Recoil
import { useRecoilState } from 'recoil';
import { userInfoAtom } from 'recoil/UserInfoRecoil';

// Utils
import { CombinedRouteProps } from 'utils/types';

// Define the PrivateRoute component
const PrivateRoute: React.FC<CombinedRouteProps> = ({
  children,
  showHeader = true,
  showFooter = true,
  maxWidth,
  alignItems = 'start',
}) => {
  const [accessToken] = useLocalStorage(STORAGE_KEYS.ACCESS_TOKEN);
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const location = useLocation();

  const fetchUserData = async () => {
    try {
      const user = await AuthService.getUserInfo();

      setUserInfo({ ...user });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (accessToken && !userInfo?.id) {
      fetchUserData();
    }
  }, [accessToken]);

  if (!accessToken) {
    return <Navigate to={ROUTES.HOME} state={{ from: location }} />;
  }

  // Authorized, so return the children wrapped with AppLayout
  return (
    <AppLayout
      showHeader={showHeader}
      alignItems={alignItems}
      showFooter={showFooter}
      maxWidth={maxWidth}
    >
      {children}
    </AppLayout>
  );
};

export default PrivateRoute;
